import { useState, useEffect } from 'react'
import { Col, Row, Space } from 'antd'
import { baseAxiosNoInfo } from '../../../tool/axios'

interface baby {
    id: string
    nick_name: string
    sex: number
    born_date: string
    height: number
    weight: number
    jaundice_value: string
    reserve_list: {
        check_in_id: string // 入住id，“入住客户管理-按条件查询列表（分页）”接口返回的check_in_id字段
        service_type_id: number // 服务类型，1满月派对
        reserve_date: string // 预约日期
    }[]
}

interface Prop {
    customerID?: string
    onFinish?: () => void
}

export default function (prop: Prop) {

    const [data, setData] = useState<baby[]>([])

    useEffect(() => {
        getClientInfo()
    }, [])

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/baby_list', {
            params: {
                check_in_id: prop.customerID
            }
        }).then((res: any) => {
            res && setData(res)
        })
    }

    return (<div className="modules" style={{ marginBottom: 40 }}>
        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 宝宝信息 */}
        <div className="top clear">
            <h3 className="fl">
                <span className="fl">宝宝信息</span>
            </h3>
        </div>

        {data.map(el => <div className="clear" style={{ marginBottom: 16 }}>
            <Row style={{ width: '100%', marginTop: 15 }}>
                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">昵称：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.nick_name || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">性别：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.sex === 0 ? '男' : '女'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">生日：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.born_date || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">身高：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.height + '(cm)' || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">体重：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.weight + '(kg)' || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">黄疸值：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.jaundice_value + '(mg/dl)' || '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>)}
    </div >)
}